import http from "utils/http";

const cityApi = {
  getCities: async () => http.get<City[]>("api/generals/cities/"),
};

export default cityApi;
